import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui';

export function SubmitButton({
	hasValidationErrors,
	loading,
}: {
	hasValidationErrors: boolean;
	loading: boolean;
}): JSX.Element {
	return (
		<Button
			type="submit"
			data-testid="submit"
			data-qa="submit"
			disabled={hasValidationErrors || loading}
			className="w-full md:w-[149px]"
			variant="primary"
			size="small"
		>
			Post update
		</Button>
	);
}
